import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { rbac } from '@utils';
import { dealerHttp } from '@network';
import { Dealer, Doctype, Document } from '@types';
import { DealerDoctypeDocument } from './DealerDoctypeDocument';
import cls from './DealerDocumentsWidget.module.css';

interface Props {
  dealer: Dealer;
  setDealer: Dispatch<SetStateAction<Dealer | null>>;
  doctypes: Doctype[] | null;
  editable: boolean;
}

export const DealerDocumentsWidget = ({ dealer, setDealer, doctypes, editable }: Props) => {
  const [documents, setDocuments] = useState<Document[]>([]);

  useEffect(() => {
    if (dealer?.id) {
      (async () => {
        const dealerDocuments = await dealerHttp.getDealerDocuments(dealer.id);
        setDocuments(dealerDocuments);
      })();
    }
  }, [dealer?.id]);

  const updateDealer = async () => {
    if (dealer?.id) {
      const [newDealer, dealerDocuments] = await Promise.all([
        dealerHttp.getById(dealer.id),
        dealerHttp.getDealerDocuments(dealer.id),
      ]);
      setDealer(newDealer);
      setDocuments(dealerDocuments);
    }
  };

  return (
    <div className={cls.container} id="dealer-docs">
      <div className={cls.documents}>
        {doctypes === null && (
          <div>Loading...</div>
        )}

        {doctypes?.length === 0 && (
          <div>No doctypes</div>
        )}

        {doctypes?.map(doctype => (
          <div className={cls.document} key={doctype.id}>
            <DealerDoctypeDocument
              doctype={doctype}
              dealer={dealer}
              documents={documents}
              setDealer={updateDealer}
              editable={editable}
              downloadable={rbac.hasDownloadRestrictionRole()}
              uploadable={rbac.hasUploadPermissionRole()}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

